import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import buildLoginDestination from 'utils/buildLoginDestination';

type Props = {
  userId: any;
  loading: boolean;
};

const useGuestRedirection = ({ userId, loading }: Props) => {
  const history = useHistory();
  useEffect(() => {
    if (!userId && !loading) {
      const destination = buildLoginDestination();
      history.push(destination);
    }
  }, [userId, loading]);
};

export default useGuestRedirection;
